'use client'

import { motion } from 'framer-motion'
import { PaymentRail } from '@/components/payment-rail'
import { CtaButton } from '@/components/cta-button'
import { EXTERNAL } from '@/lib/site'

export function Hero() {
  return (
    <section className="relative overflow-hidden pt-8 pb-24 sm:pt-12 md:pt-16 bg-white">
      <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        {/* Two-column hero layout */}
        <div className="grid gap-8 lg:gap-12 lg:grid-cols-2 items-start">
          {/* Left column - Text content */}
          <div>
            {/* Badge */}
            <motion.span
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.4 }}
              className="inline-flex items-center gap-2 rounded-full border border-brand/20 bg-brand/5 px-4 py-2 text-sm font-medium text-brand"
            >
              <span className="size-2 rounded-full bg-brand" />
              Banking + Stablecoins, Unified
            </motion.span>

            {/* Main heading with improved typography */}
            <motion.h1
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.05 }}
              className="mt-8 text-balance text-5xl font-bold tracking-tight text-foreground sm:text-6xl lg:text-5xl"
            >
              Move money without friction.
            </motion.h1>

            {/* Subheading with clearer messaging */}
            <motion.p
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.1 }}
              className="mt-8 max-w-2xl text-pretty text-sm leading-relaxed text-foreground/70"
            >
              Rombex connects traditional banking infrastructure with stablecoin networks. 
              Send, receive, hold, and orchestrate payments globally through one unified platform.
            </motion.p>

            {/* Single CTA button */}
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.15 }}
              className="mt-10 flex items-center text-2xl"
            >
              <CtaButton href="/contact?intent=sales" size="md" arrow external>
                Talk to Sales
              </CtaButton>
            </motion.div>
          </div>

          {/* Right column - Growth globe illustration */}
          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="hidden lg:flex items-center justify-center"
          >
            <img
              src="/growth-globe.png"
              alt="Global growth and positive financial trends"
              className="w-full max-w-md h-auto"
            />
          </motion.div>
        </div>

        {/* Payment rail with enhanced spacing */}
        <motion.div
          initial={{ opacity: 0, y: 32 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.2 }}
          className="mx-auto mt-20 max-w-5xl px-4"
        >
          <PaymentRail />
        </motion.div>
      </div>
    </section>
  )
}
